<div class="durd-page">
  <header class="durd-back">
    <button (click)="goBack()" class="durd-btn-ghost">
      <mat-icon>arrow_back</mat-icon> Volver al listado
    </button>
  </header>

  <div *ngIf="loading" class="durd-loading">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Cargando detalle...</span>
  </div>

  <div *ngIf="errorMessage && !loading" class="durd-error">
    <mat-icon>error_outline</mat-icon>
    {{ errorMessage }}
    <button (click)="loadDetail()">Reintentar</button>
  </div>

  <ng-container *ngIf="request && !loading">
    <!-- Cabecera -->
    <section class="durd-summary">
      <div class="durd-summary__main">
        <h1>Solicitud #{{ request.id }}</h1>
        <p>
          <strong>Usuario:</strong> #{{ request.usuarioId }} ·
          <strong>Estado:</strong> {{ estadoLabel(request.estado) }} ·
          <strong>Plazo:</strong> {{ request.deadlineAt | date: 'short' }}
        </p>
        <p *ngIf="request.motivo">
          <strong>Motivo:</strong> {{ request.motivo }}
        </p>
        <p *ngIf="request.createdByEmail">
          <strong>Creada por:</strong> {{ request.createdByEmail }} ·
          {{ request.createdAt | date: 'short' }}
        </p>
      </div>

      <div class="durd-summary__chips">
        <span *ngIf="request.vencida" class="durd-chip durd-chip--expired">
          <mat-icon>schedule</mat-icon> Vencida
        </span>
        <span *ngIf="request.riskReported" class="durd-chip durd-chip--risk">
          <mat-icon>warning</mat-icon> Reportada
        </span>
        <span class="durd-chip durd-chip--rejects">
          Reintentos {{ request.rejectCount }}/2
        </span>
      </div>
    </section>

    <!-- Banner riesgo -->
    <div *ngIf="request.riskReported" class="durd-risk-banner">
      <mat-icon>warning</mat-icon>
      <div>
        <strong>Persona reportada</strong>
        <p>{{ riskDetailText(request) }}</p>
      </div>
    </div>

    <!-- Acciones globales -->
    <section class="durd-actions" *ngIf="submittedItems.length">
      <button
        class="durd-btn durd-btn--primary"
        [disabled]="!hasSelection"
        (click)="approveSelected()"
      >
        <mat-icon>check_circle</mat-icon>
        Aprobar seleccionados ({{ selectedToApprove.size }})
      </button>
      <button
        class="durd-btn durd-btn--danger-ghost"
        (click)="cancelRequest()"
        *ngIf="request.estado === 'PENDING'"
      >
        <mat-icon>cancel</mat-icon> Cancelar solicitud
      </button>
    </section>

    <!-- Items -->
    <section class="durd-items">
      <article
        *ngFor="let item of request.items"
        class="durd-item"
        [class.durd-item--rejected]="item.status === 'REJECTED'"
        [class.durd-item--approved]="item.status === 'APPROVED'"
        [class.durd-item--submitted]="item.status === 'SUBMITTED'"
      >
        <header class="durd-item__header">
          <label class="durd-item__select" *ngIf="item.status === 'SUBMITTED'">
            <input
              type="checkbox"
              [checked]="selectedToApprove.has(itemIdOf(item))"
              (change)="toggleSelect(item)"
            />
          </label>
          <strong>{{ labelOf(item) }}</strong>
          <span
            class="durd-chip"
            [style.background]="statusColor(item.status) + '22'"
            [style.color]="statusColor(item.status)"
            [style.border-color]="statusColor(item.status) + '55'"
          >
            {{ statusLabel(item.status) }}
          </span>
          <!-- Trazabilidad de revisión: aparece cuando el item ya fue
               evaluado por un operador (APPROVED / REJECTED). Muestra
               el email directo — antes era un cognitoId ilegible. -->
          <span
            *ngIf="reviewedByLabel(item) as reviewedBy"
            class="durd-item__reviewer"
            [title]="'Item revisado por ' + reviewedBy"
          >
            <mat-icon>person</mat-icon>
            {{ reviewedBy }}
          </span>
        </header>

        <!-- Before / After para items escalares -->
        <div *ngIf="!isFile(item)" class="durd-item__diff">
          <div class="durd-diff">
            <span class="durd-diff__label">Actual</span>
            <span class="durd-diff__value">{{ formatValue(item.currentValue, item.fieldKey) }}</span>
          </div>
          <mat-icon class="durd-diff__arrow">arrow_forward</mat-icon>
          <div class="durd-diff durd-diff--new">
            <span class="durd-diff__label">Propuesto</span>
            <span class="durd-diff__value">{{ formatValue(item.submittedValue, item.fieldKey) }}</span>
          </div>
        </div>

        <!-- Preview de archivo. Usamos `itemPreviewUrl(item)` que cubre
             `previewUrl` (backend real) y `fileSignedUrl` (alias legacy). -->
        <ng-container *ngIf="isFile(item)">
          <ng-container *ngIf="itemPreviewUrl(item) as url">
            <!-- Imagen: click para abrir lightbox fullscreen -->
            <div
              *ngIf="isImageUrl(url)"
              class="durd-item__file durd-item__file--clickable"
              (click)="openLightbox(url)"
              title="Click para ver en grande"
            >
              <img [src]="url" alt="Documento" />
              <div class="durd-item__file-zoom">
                <mat-icon>zoom_in</mat-icon>
                <span>Ver en grande</span>
              </div>
            </div>

            <!-- PDF: abrir en nueva pestaña -->
            <button
              *ngIf="isPdfUrl(url)"
              type="button"
              class="durd-item__file-link"
              (click)="openExternal(url)"
            >
              <mat-icon>picture_as_pdf</mat-icon>
              <span>Abrir PDF en pestaña nueva</span>
            </button>

            <!-- Otro tipo de archivo: link genérico -->
            <button
              *ngIf="!isImageUrl(url) && !isPdfUrl(url)"
              type="button"
              class="durd-item__file-link"
              (click)="openExternal(url)"
            >
              <mat-icon>attach_file</mat-icon>
              <span>Abrir archivo</span>
            </button>
          </ng-container>

          <!-- Sin URL todavía: placeholder -->
          <div *ngIf="!itemPreviewUrl(item)" class="durd-item__file-empty">
            <mat-icon>image_not_supported</mat-icon>
            <span>El cliente todavía no subió este documento</span>
          </div>
        </ng-container>

        <!-- OCR -->
        <div *ngIf="item.ocrExtracted" class="durd-item__ocr">
          <h4>Datos leídos del documento (OCR)</h4>
          <ul>
            <li *ngIf="item.ocrExtracted.nombres">Nombres: {{ item.ocrExtracted.nombres }}</li>
            <li *ngIf="item.ocrExtracted.apellidos">Apellidos: {{ item.ocrExtracted.apellidos }}</li>
            <li *ngIf="item.ocrExtracted.fechaNacimiento">Fecha nac.: {{ item.ocrExtracted.fechaNacimiento }}</li>
            <li *ngIf="item.ocrExtracted.numeroId">N° ID: {{ item.ocrExtracted.numeroId }}</li>
          </ul>
        </div>

        <!-- Verificación facial (Rekognition) — sólo aparece si el
             backend adjuntó el resultado en el item selfie. Informa al
             operador; no bloquea la decisión de aprobar/rechazar. -->
        <ng-container *ngIf="item.facialVerification as fv">
          <ng-container *ngIf="facialVerificationSummary(fv) as summary">
            <div
              class="durd-item__facial"
              [class.durd-item__facial--ok]="summary.kind === 'ok'"
              [class.durd-item__facial--warn]="summary.kind === 'warn'"
              [class.durd-item__facial--error]="summary.kind === 'error'"
            >
              <mat-icon *ngIf="summary.kind === 'ok'">verified</mat-icon>
              <mat-icon *ngIf="summary.kind === 'warn'">warning</mat-icon>
              <mat-icon *ngIf="summary.kind === 'error'">error_outline</mat-icon>
              <div>
                <strong>{{ summary.label }}</strong>
                <small>
                  Umbral: {{ fv.threshold }}%
                  <ng-container *ngIf="fv.comparedWith">
                    · comparado con {{ fv.comparedWith }}
                  </ng-container>
                  <ng-container *ngIf="fv.checkedAt">
                    · {{ fv.checkedAt | date: 'short' }}
                  </ng-container>
                </small>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Flags con explicación embebida — antes eran pills sin
             contexto ("Cambio de identidad", "Ya existe en usuarios") y
             al operador le quedaba la duda del "porqué". Ahora cada
             flag despliega la razón concreta y qué acción tomar. -->
        <div class="durd-item__flags" *ngIf="item.identityChange || numeroIdMatchLabel(item.numeroIdMatch)">
          <div
            *ngIf="item.identityChange"
            class="durd-flag-block durd-flag-block--identity"
          >
            <mat-icon>warning</mat-icon>
            <div>
              <strong>Cambio de identidad</strong>
              <small>{{ identityChangeExplanation(item) }}</small>
            </div>
          </div>
          <div
            *ngIf="numeroIdMatchLabel(item.numeroIdMatch) as label"
            class="durd-flag-block durd-flag-block--match"
          >
            <mat-icon>info</mat-icon>
            <div>
              <strong>{{ label }}</strong>
              <small *ngIf="numeroIdMatchExplanation(item.numeroIdMatch) as explanation">
                {{ explanation }}
              </small>
            </div>
          </div>
        </div>

        <!-- Motivo de rechazo previo -->
        <p *ngIf="item.status === 'REJECTED' && item.rejectReason" class="durd-item__reject-reason">
          <mat-icon>info</mat-icon> {{ item.rejectReason }}
        </p>

        <!-- Acciones por item -->
        <footer class="durd-item__actions" *ngIf="item.status === 'SUBMITTED'">
          <button class="durd-btn durd-btn--danger-ghost" (click)="rejectItem(item)">
            <mat-icon>thumb_down</mat-icon> Rechazar
          </button>
        </footer>
      </article>
    </section>

    <!-- Datos actuales del usuario — snapshot para que el operador
         compare contra los valores que el cliente está proponiendo
         arriba. Se carga aparte del getDetail() y falla silenciosa:
         si /users no responde, la sección no se renderiza y el resto
         del detalle sigue funcional. -->
    <section
      *ngIf="currentUserLoading || currentUser"
      class="durd-current-user"
    >
      <header class="durd-current-user__header">
        <mat-icon>account_circle</mat-icon>
        <div>
          <h3>Datos actuales del usuario</h3>
          <small>Snapshot para validar contra los cambios propuestos arriba.</small>
        </div>
      </header>

      <div *ngIf="currentUserLoading" class="durd-current-user__loading">
        <mat-spinner diameter="20"></mat-spinner>
        <span>Cargando datos del usuario…</span>
      </div>

      <div
        *ngIf="!currentUserLoading && currentUser"
        class="durd-current-user__grid"
      >
        <div
          *ngFor="let group of currentUserGroups"
          class="durd-current-user__group"
        >
          <h4>{{ group.title }}</h4>
          <dl>
            <ng-container *ngFor="let entry of group.entries">
              <dt>{{ entry.label }}</dt>
              <dd>{{ entry.value }}</dd>
            </ng-container>
          </dl>
        </div>
      </div>

      <div
        *ngIf="!currentUserLoading && currentUser && currentUserDocuments.length"
        class="durd-current-user__docs"
      >
        <h4>Documentos actuales</h4>
        <div class="durd-current-user__docs-grid">
          <button
            *ngFor="let doc of currentUserDocuments"
            type="button"
            class="durd-current-user__doc"
            (click)="openLightbox(doc.url)"
            [title]="'Ver ' + doc.label"
          >
            <img [src]="doc.url" [alt]="doc.label" />
            <span>{{ doc.label }}</span>
          </button>
        </div>
      </div>
    </section>
  </ng-container>

  <!-- Lightbox fullscreen para previsualizar imágenes en grande.
       Click en el backdrop o en el botón cierra. -->
  <div
    *ngIf="lightboxUrl"
    class="durd-lightbox"
    (click)="closeLightbox()"
    role="dialog"
    aria-modal="true"
  >
    <button
      type="button"
      class="durd-lightbox__close"
      (click)="$event.stopPropagation(); closeLightbox()"
      aria-label="Cerrar"
    >
      <mat-icon>close</mat-icon>
    </button>
    <img
      [src]="lightboxUrl"
      alt="Documento"
      class="durd-lightbox__img"
      (click)="$event.stopPropagation()"
    />
  </div>
</div>
